import { apiWrapper, apiCancel } from "../../wrapper";

export const initial = "pensiun";
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL;
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE;
const outputType = "json";

export const pensiunCreate = "Kepegawaian/Pensiun/create/";
export const pensiunList = "Kepegawaian/Pensiun/list/";
export const pensiunListparicipant = "Kepegawaian/Pensiun/list_participant/";
export const pensiunListMonitoring = "Kepegawaian/Pensiun/list_monitoring/";
export const pensiunDetail = "Kepegawaian/Pensiun/detail/";
export const pensiunUpdate = "Kepegawaian/Pensiun/update/";
export const pensiunInactive = "Kepegawaian/Pensiun/inactive/";
export const pensiunActive = "Kepegawaian/Pensiun/active/";
export const masterEmployee = "Kepegawaian/Pensiun/list_employee/";
export const masterType = "Kepegawaian/Pensiun/list_type/";
export const masterRetiredDocument = "Kepegawaian/Pensiun/list_document/";

export const exportExcel = "Kepegawaian/Pensiun/exportExcel/";
export const pensiunSubmit = "Kepegawaian/Pensiun/submit/";
export const pensiunSubmission = "Kepegawaian/Pensiun/submission/";
export const loadEmployee = "Kepegawaian/Pensiun/load_employee/";
export const syaratDokumen = "Kepegawaian/Pensiun/list_syarat/";
export const listTahun = "Kepegawaian/Pensiun/load_year/";
export const detailSubmission = "Kepegawaian/Pensiun/detail_submission/";
export const pensiunApprove = "Kepegawaian/Pensiun/approve/";
export const pensiunDetailApprovePeriod =
  "Kepegawaian/Pensiun/approveperioddetail/";
export const pensiunApprovePeriod = "Kepegawaian/Pensiun/approveperiodsubmit/";
export const pensiunDocuments = "Kepegawaian/Pensiun/load_syarat_pensiun/";
export const pensiunExport = "Kepegawaian/Pensiun/export_excel/";

// Data Rekomendasi
export const generatePegawai = "Kepegawaian/Pensiun/generatePegawai/";
export const prosesPegawai = "Kepegawaian/Pensiun/prosesPegawai/";

// DMS
export const pensiunGetFolderList = "Kepegawaian/Pensiun/getFolderList/";
export const pensiunGetDocument = "Kepegawaian/Pensiun/getDocument/";

export const masterBank = "Master/List/bank/";

//export const cancelToken = () => apiCancel
export const cancelToken = () => {
  return apiCancel();
};
export const apiRequest = async (
  method,
  route,
  data = { params: null, body: null, cancelToken: null },
  needToken = true
) => {
  if (needToken) {
    const thisTime = Math.floor(Date.now() / 1000);
    const expire = localStorage.getItem(initial + "accessExpired");
    if (expire < thisTime) {
      await apiWrapper(
        baseUrl,
        initial,
        appCode,
        outputType,
        "post",
        "auth/getAccessToken/",
        data
      )
        .then((result) => {
          localStorage.setItem(
            initial + "accessToken",
            result.response.access_token
          );
          return apiWrapper(
            baseUrl,
            initial,
            appCode,
            outputType,
            method,
            route,
            data
          );
        })
        .catch((result) => {
          return Promise.reject("Tidak dapat mengambil accessToken");
        });
    } else {
      return apiWrapper(
        baseUrl,
        initial,
        appCode,
        outputType,
        method,
        route,
        data
      );
    }
  }
  return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data);
};
